import shortid from "shortid";
(function () {
  window.location.href = `/balance?cacheId=${shortid()}`;
})();

export default {};
